module.exports = __webpack_public_path__ + "static/media/sulution-agrutucal.96a6ae82.png";